export default "__VITE_ASSET__Cxi064Mu__"